module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content"
  }, [_c('div', {
    staticClass: "pp-header pp-header--simple pp-header-image-generic pp-header--mobile-small"
  }, [_c('div', {
    staticClass: "pp-header__title"
  }, [_vm._v("\n            " + _vm._s(_vm.account ? _vm.account.name : 'Guest') + "\n        ")])]), _vm._v(" "), (!_vm.account) ? _c('div', {
    staticClass: "pp-content__page"
  }, [_c('div', {
    staticClass: "pp-account"
  }, [_c('div', {
    staticClass: "pp-account__row"
  }, [_c('div', {
    staticClass: "pp-account__header"
  }, [_vm._v("\n                    Free plays remaining\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-account__value"
  }, [_vm._v("\n                    " + _vm._s(_vm.freePlays) + "\n                ")])]), _vm._v(" "), (_vm.$root.view == 'mobile') ? _c('a', {
    staticClass: "pp-account__button",
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-auth?mode=mobile"
    }
  }, [_vm._v("\n                Login\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'desktop') ? _c('a', {
    staticClass: "pp-account__button",
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-auth"
    }
  }, [_vm._v("\n                Login\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'desktop' && !_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-account__button",
    attrs: {
      "href": "https://www.pristineclassical.com/account/register",
      "target": "_blank"
    }
  }, [_vm._v("\n                Create account\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$root.view == 'mobile' && !_vm.$root.isIos) ? _c('a', {
    staticClass: "pp-account__button",
    attrs: {
      "href": "https://www.pristineclassical.com/pages/player-signup?from_page=subscribe&mode=mobile"
    }
  }, [_vm._v("\n                Create account\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.account) ? _c('div', {
    staticClass: "pp-content__page"
  }, [_c('div', {
    staticClass: "pp-account"
  }, [_c('div', {
    staticClass: "pp-account__row"
  }, [_c('div', {
    staticClass: "pp-account__header"
  }, [_vm._v("\n                    Plan\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-account__value"
  }, [_vm._v("\n                    " + _vm._s(_vm.account.plan) + "\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "pp-account__button pp-account__button--outline",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                Logout\n            ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c1e150f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Account.vue
// module id = 127
// module chunks = 0 1